export default {
  edit_profile: 'تعديل الحساب',
  my_account: 'حسابي الخاص',
  balance: 'الرصيد',
  available_for_withdrawal: 'متاح للسحب',
  amount_in_hold: 'المبلغ المعلق',
  latest_news: 'آخر الأخبار',
  more_news: 'المزيد من الأخبار'
};